import { SalesChannelUpdatePage } from '@/features/sales-channel/pages/SalesChannelUpdatePage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/sales-channel/$id/update')({
  component: SalesChannelUpdatePage,
})
